// 9fbef606107a605d69c0edbcd8029e5d
import logger from '@tcp/core/src/utils/loggerInstance';
import { getAPIConfig } from '@tcp/core/src/utils';
import handler from '../../../handler';

/**
 * Responsible for content fetching using content ID
 */
export const DataAbstractor = {
  getData: async (id, catGrpId, moduleTypeName) => {
    const { language } = getAPIConfig();
    return handler
      .fetchModuleDataFromGraphQL({
        name: 'moduleDynamic',
        data: {
          contentId: id,
          lang: language !== 'en' ? language : '',
          slot: moduleTypeName,
        },
      })
      .then((response) => (response ? response.data : {}));
  },
  processData: async (data, catGrpId, isHplp) => {
    const { set, composites: { linkedImage, hplpLinkedImage } = {} } = data.EspotPlpSection || {};
    const providerObj = set.find((item) => item.key === 'provider');
    const providerKey = providerObj ? providerObj.key : null;
    const providerVal = providerObj ? providerObj.val : null;

    const finalLinkedImage = isHplp ? hplpLinkedImage : linkedImage;

    if (!finalLinkedImage) {
      return {};
    }

    return {
      eSpotCatGrpId: catGrpId,
      isESpotPlpContent: true,
      linkedImage: finalLinkedImage,
      [providerKey]: providerVal,
    };
  },
};

/**
 * Responsible for loading the module Dynamic from CMS
 * @param {String} cid - Content ID
 */
export const getModuleDynamic = async (cid, catGrpId, moduleTypeName, isHplp) => {
  const { getData, processData } = DataAbstractor;
  let response = {};

  try {
    const data = await getData(cid, catGrpId, moduleTypeName);
    response = await processData(data, catGrpId, isHplp);
  } catch (error) {
    logger.error(error);
  }
  return response;
};
